import './sky-large-icon-info.scss';

let swipers = [];

/* helper used for CLS guard */
const isReallyMobile = () => window.matchMedia('(max-width: 1024px)').matches;

function initializeProductSliders() {
    /* stop desktop DOM shuffle */
    if (!isReallyMobile()) {
        return;
    }

    const sliders = document.querySelectorAll('.sky-large-icon-info-block .icon-info-rows');

    sliders.forEach((slider, index) => {
        if (!slider.classList.contains('initialized')) {
            const swiperContainer = document.createElement('div');
            swiperContainer.classList.add('swiper-container');

            const swiperWrapper = document.createElement('div');
            swiperWrapper.classList.add('swiper-wrapper');

            const slides = slider.querySelectorAll('.icon-info-row');
            slides.forEach(slide => {
                const swiperSlide = document.createElement('div');
                swiperSlide.classList.add('swiper-slide');
                swiperSlide.appendChild(slide);
                swiperWrapper.appendChild(swiperSlide);
            });

            swiperContainer.appendChild(swiperWrapper);
            slider.parentNode.insertBefore(swiperContainer, slider);
            slider.classList.add('initialized');
            slider.style.display = 'none'; // Hide the original slider

            const swiper = new Swiper(swiperContainer, {
                slidesPerView: 1,
                loop: true,
                speed: 600,
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false
                },
            });

            swipers.push(swiper);
        }
    });
}

function destroyProductSliders() {
    swipers.forEach(swiper => swiper.destroy(true, true));
    swipers = [];
    const sliders = document.querySelectorAll('.sky-large-icon-info-block .icon-info-rows');

    sliders.forEach(slider => {
        if (slider.classList.contains('initialized')) {
            const swiperContainer = slider.previousElementSibling;
            if (swiperContainer && swiperContainer.classList.contains('swiper-container')) {
                const slides = swiperContainer.querySelectorAll('.swiper-slide');
                slides.forEach(slide => {
                    const originalIcon = slide.firstChild;
                    if (originalIcon) {
                        slider.appendChild(originalIcon);
                    }
                });
                swiperContainer.remove();
            }
            slider.classList.remove('initialized');
            slider.style.display = 'flex'; // Show the original slider
        }
    });
}

function handleResize() {
    if (isReallyMobile()) {
        if (swipers.length === 0) {
            initializeProductSliders();
        }
    } else {
        if (swipers.length > 0) {
            destroyProductSliders();
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    handleResize();
    window.addEventListener('resize', handleResize);
});